// Utilitaires pour parser le bloc <FOLLOWUP>...</FOLLOWUP> dans les reponses IA

// Detecte un bloc partiel (en cours de streaming) - retourne true si on a vu "<FOLLOWUP" mais pas la fin
export function hasPartialFollowup(text) {
  if (!text) return false;
  // Detecte aussi "<FOLLOWUP" partiel (sans le > final)
  const startMatch = text.search(/<FOLLOWUP/i);
  if (startMatch === -1) return false;
  const end = text.toUpperCase().indexOf("</FOLLOWUP>", startMatch);
  return end === -1;
}

// Strip le bloc <FOLLOWUP> du texte affiche, qu'il soit complet ou partiel
export function stripFollowup(text) {
  if (!text) return text;
  // 1. On enleve d'abord les blocs complets <FOLLOWUP>...</FOLLOWUP>
  let cleaned = text.replace(/<FOLLOWUP>[\s\S]*?<\/FOLLOWUP>/gi, "");
  // 2. Si un debut <FOLLOWUP (ou <FOLLOWU, <FOLLOW, etc.) traine sans fin (streaming partiel ou bloc malforme)
  //    on coupe a partir du premier "<FOLLOW"
  const partialMatch = cleaned.search(/<FOLLOW/i);
  if (partialMatch !== -1) {
    cleaned = cleaned.slice(0, partialMatch);
  }
  return cleaned.replace(/\n{3,}/g, "\n\n").replace(/\s+$/, "");
}

// Extrait les questions FOLLOWUP du texte (retourne [] si rien ou JSON invalide)
export function parseFollowup(text) {
  if (!text) return [];
  const matches = text.match(/<FOLLOWUP>([\s\S]*?)<\/FOLLOWUP>/);
  if (!matches) return [];
  const rawJson = matches[1].trim();
  try {
    const parsed = JSON.parse(rawJson);
    if (!Array.isArray(parsed)) return [];
    // Validation legere
    return parsed
      .filter((q) => q && typeof q === "object" && typeof q.q === "string")
      .map((q) => ({
        q: q.q,
        type: q.type === "text" ? "text" : "qcm",
        choices: Array.isArray(q.choices) ? q.choices.slice(0, 6) : [],
        placeholder: typeof q.placeholder === "string" ? q.placeholder : "",
      }))
      .slice(0, 4);
  } catch {
    return [];
  }
}

// Construit le message texte a envoyer apres reponses du widget
export function buildFollowupResponse(questions, answers) {
  const lines = ["Voici les precisions demandees :", ""];
  questions.forEach((q, idx) => {
    const a = answers[idx];
    if (a === null || a === undefined || a === "") return;
    if (a === "__SKIP__") {
      lines.push(`- ${q.q} : (non precise)`);
    } else {
      lines.push(`- ${q.q} : ${a}`);
    }
  });
  return lines.join("\n");
}
